/*
 * Copyright (c) 2026.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Nikita Tropin <ntropin@yandex.ru>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

export interface MarketplaceYml {
  id: number;
  header: string;
  company: string;
  pos: number;
  shop: string;
  deliveryDays: string;
  deliveryOrderBefore: number;
  isCourierDelivery: boolean;
  isGeneralDelivery: boolean;
  isPickupDelivery: boolean;
  pickupDays: string;
  pickupOrderBefore: number;
  platform: string;
  url: string;
  createdAt: Date;
  enabled: boolean;
  deleted?: boolean;
  damRelatedCollectionId?: boolean;
  priceTypeId?: boolean;
  oldPriceTypeId?: boolean;
  purchasePriceTypeId?: boolean;
  additionalExpensesPriceTypeId?: boolean;
  cofinancePriceTypeId?: boolean;
  manualId?: number;
  featureVideoId?: number;
  featureBoxCountId?: number;
  featureVendorCodeId?: number;
  featureTypeId?: number;
  featureCargoTypesId?: number;
  featureAdultId?: number;
  featureDownloadableId?: number;
  featurePeriodOfValidityDaysId?: number;
  featureCommentValidityDaysId?: number;
  featureServiceLifeDaysId?: number;
  featureCommentLifeDaysId?: number;
  featureWarrantyDaysId?: number;
  featureCommentWarrantyId?: number;
  featureCertificateId?: number;
  featureTnVedCodesId?: number;
  featureCtruCodeId?: number;
  featureAgeId?: number;
  featureArchivedId?: number;
  featureUrlId?: number;
  featureDisabledId?: number;
  featureConditionId?: number;
  featureQualityId?: number;
  featureReasonId?: number;
  featureAvailableId?: number;
  featureDeliveryId?: number;
  featureDeliveryOptionsId?: number;
  featurePickupId?: number;
  featurePickupOptionsId?: number;
  featureNameId?: number;
  featureArticleId?: number;
  featureDescriptionId?: number;
  warehouseId?: number;
  currencyId?: number;
  isExceptionMode?: boolean;
  tags?: number[];
  features?: number[];
}
